// 知識庫上傳的格式——前端唯一定義處（建立知識庫頁與文件管理頁共用）。
// 只列常用格式；後端實際可處理的更多（agent_skills/shared/ingestion_base/io/
// source_normalizer.py 的 SUFFIX_ROUTES）。rag_app.py 歡迎訊息列的是同一組。
export const KB_ACCEPTED_TYPES = {
  'application/pdf': ['.pdf'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
  'application/vnd.ms-powerpoint': ['.ppt'],
  'text/plain': ['.txt'],
  'text/markdown': ['.md'],
  'image/png': ['.png'],
  'image/jpeg': ['.jpg']
};

// 顯示給使用者看的格式說明（與歡迎訊息一致）
export const KB_FORMATS_LABEL = '.pdf .docx .doc .pptx .ppt .txt .md .png .jpg';
